/** @jsx jsx */
import { jsx, useThemeUI, Theme as ThemeUITheme } from "theme-ui";
import { useEffect } from "react";
import { Flex, Box, Heading } from "rebass";
import ProjectTitle, { ProjectData } from "./ProjectTitle";
//import imgCover1 from "../img/bose/card-image-bose-ds.png";
//import imgCover2 from "../static/models/textures/bose-cover-immersive-stories.jpg";

const projectsData = (theme: ThemeUITheme): ProjectData[] => [
  {
    title: "SOLID FOUNDATIONS",
    tagline: "Setting the foundations for an immersive shopping experience.",
    discipline: "eCommerce, Website",
    id: "16",
    page: "/work/bose/bose-design-system",
    year: "2024",
    label: "Case Study",
    //url: imgCover1,
    urlbg: (theme?.colors?.boseProjectBgDs as string ) || "backgroundElevationOpacity",
    urlcolor: (theme?.colors?.boseProjectTextDs as string ) || "text",
  },
  {
    title: "DESIGN SYSTEM(S)",
    tagline: "Scalable systematic approach to build-in visual consistency. Informed by OOUX.",
    discipline: "eCommerce, Website, Multi-brand",
    id: "10",
    page: "/work/accell-group/design-system",
    year: "2020",
    label: "Case Study",
    urlbg: (theme?.colors?.accellProjectBgDs as string ) || "backgroundElevationOpacity",
    urlcolor: (theme?.colors?.accellProjectTextDs as string ) || "text",
  },
  {
    title: "eCOMMERCE PLATFORM",
    tagline: "Headless eCommerce Platform for Multi-Brands. Built on Gatsby.",
    discipline: "Headless, Multi-brand",
    id: "14",
    page: "/work/accell-group/ecom-platform/",
    year: "2020",
    label: "Case Study",
    urlbg: (theme?.colors?.accellProjectBgECom as string ) || "backgroundElevationOpacity",
    urlcolor: (theme?.colors?.accellProjectTextECom as string ) || "text",
  },
  //{
    //title: "LAPIERRE",
    //tagline: "Design System applied, from brand book to a complete shopping experience.",
    //discipline: "eCommerce, Design Systems, Visual design",
    //id: "12",
    //page: "/work/accell-group/lapierre/",
    //year: "2020 - 2021",
    //label: "",
  //},
  //{
    //title: "OBERON",
    //tagline: "Desc",
    //discipline: "Design Systems, Multi-Brand, App, Website",
    //id: "18",
    //page: "/work/test/",
    //year: "2020 - 2021",
    //label: "",
  //}
];

const ProjectTitleListing = () => {
  const { theme } = useThemeUI();
  const projects = projectsData(theme);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section>
      <Flex
        flexWrap="wrap"
        justifyContent="space-between"
        variant="container"
      >
        <Box width={[1 / 1]} mb={[3]}>
          <Heading as="h3" variant="catHeading">
            Featured work
          </Heading>
        </Box>
        {/* Project title list */}
        {projects.map((project, index) => (
          <ProjectTitle
            page={project.page}
            title={project.title}
            tagline={project.tagline}
            discipline={project.discipline}
            year={project.year}
            label={project.label}
            url={project.url}
            urlbg={project.urlbg}
            urlcolor={project.urlcolor}
            id={project.id}
            key={project.id!.toString()}
            index={index}
          />
        ))}
      </Flex>
    </section>
  );
};

export default ProjectTitleListing;
